import React from 'react';
import Mobiscroll from '../Vendor/Mobiscroll/mobiscroll.custom-4.7.3.min.js';
import { SearchIcon } from "./SearchIcon";
import additionalfn from "../../_additionalfn";
import { Mask } from "./Mask";

export class ScrollerMobiscroll extends React.Component {
    constructor(props) {
        super(props);
        
        this.parentRef = React.createRef();
    }
    
    formatValue = (data) => { 
        return [data[0],data[1]];
    }
    
    onClear = (event, inst) => { 
        this.props.onChange(null);
    }
    
    onSet = (event, inst) => { 
        var instanceVal = inst.getVal();
        this.props.onChange(instanceVal);
    }
    
    onInit(event, inst) { 
        if (this.props.value) { 
            inst.setVal(this.props.value,true);
        }
    }
    
    placeholder(){ 
        if(!this.props.value) return this.props.placeholder;
        
        var from = this.props.value[0],
            to = this.props.value[1],
            separator = this.props.separator ? this.props.separator : '-';
        
        for(var i in this.props.fromValues){
            if(this.props.fromValues[i].value === from) from = this.props.fromValues[i].display;
        }
        
        for(var i in this.props.toValues){
            if(this.props.toValues[i].value === to) to = this.props.toValues[i].display;
        }
        
        if(from === to) return to+'+';
        
        return from + separator + to;
    }

    handleClick = (e) => {
        this.parentRef.current.getElementsByTagName('INPUT')[0].click();
    }
    
    render() {
        const { fromValues,toValues } = this.props, 
            validateRule = this.props.validateRule ? this.props.validateRule : false,
            placeholder = this.placeholder();
        
        return (   
            <div className={(this.props.className ? this.props.className : '')} onClick={this.handleClick.bind(this)}>
                <div className="flex items-center" ref={this.parentRef}>
                    <SearchIcon src={this.props.iconSrc} show={this.props.withIcon} />
                    <div className={(this.props.value ? 'blue1' : 'grey1')}>{placeholder}</div>
                    <Mobiscroll.Scroller
                        key="scroller"
                        theme="ios-cv"
                        display={this.props.displayType ? this.props.displayType : 'bubble'}
                        className="hide"
                        setText={this.props.labels.select}
                        clearText={this.props.labels.clear}
                        cancelText={this.props.labels.cancel}
                        buttons = {['set','clear','cancel']}
                        wheels={[
                                [{
                                    circular: false,
                                    data: fromValues,
                                    label: this.props.labels.from
                                }, {
                                    circular: false,
                                    data: toValues,
                                    label: this.props.labels.to
                                }]
                            ]}
                        showLabel={true}
                        validate={function (event, inst) {
                            var i,
                                values = event.values,
                                disabledValues = [],
                                to = null,
                                from = null;

                            for (i = 0; i < toValues.length; ++i) { 
                                from = additionalfn.stripStringtoNumber(values[0],validateRule);
                                to = additionalfn.stripStringtoNumber(toValues[i].value,validateRule);

                                if (to <= from) {
                                    disabledValues.push(toValues[i].value);
                                }
                            }

                            return {
                                disabled: [
                                    [], disabledValues
                                ]
                            }
                        }}
                        formatValue={this.formatValue}
                        placeholder={this.props.placeholder}
                        lang={this.props.lang}
                        onInit={this.onInit.bind(this)}
                        onSet={this.onSet}
                        onClear={this.onClear}
                    />
                </div>
                {this.props.disabled ?
                <Mask />
                :''}
            </div>
        );
    }
}
